(() => {
  const sectionSelector = '[data-team-vitality-comfort-victory]';
  const featureSelector = '[data-tvcv-feature]';
  const featureItemSelector = '[data-tvcv-feature-item]';
  const detailStackSelector = '[data-tvcv-detail-stack]';
  const inViewClass = 'is-in-view';
  const revealStateAttribute = 'data-bl-reveal-state';
  const revealPlayingState = 'playing';
  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add(inViewClass);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.28 })
    : null;

  const revealSection = (section) => {
    if (!section) return;

    if (window.matchMedia('(max-width: 767px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.classList.add(inViewClass);
      return;
    }

    if (revealObserver) {
      revealObserver.observe(section);
      return;
    }

    section.classList.add(inViewClass);
  };

  const syncBlacklyteReveal = (section) => {
    if (!section || !('MutationObserver' in window)) return;

    if (section.getAttribute(revealStateAttribute) === revealPlayingState) {
      section.classList.add(inViewClass);
      return;
    }

    const observer = new MutationObserver(() => {
      if (section.getAttribute(revealStateAttribute) !== revealPlayingState) return;

      section.classList.add(inViewClass);
      observer.disconnect();
    });

    observer.observe(section, { attributes: true, attributeFilter: [revealStateAttribute] });
  };

  const closeFeatures = (section) => {
    if (!section) return;

    const featuresRoot = section.querySelector('.team-vitality-comfort-victory__features');
    if (featuresRoot) {
      featuresRoot.classList.remove('is-detail-open');
    }

    section.querySelectorAll(featureItemSelector).forEach((item) => {
      const feature = item.querySelector(featureSelector);
      const detailStack = item.querySelector(detailStackSelector);

      item.classList.remove('is-active');
      if (feature) {
        feature.classList.remove('is-active');
        feature.setAttribute('aria-expanded', 'false');
      }
      if (detailStack) {
        detailStack.hidden = true;
      }
    });
  };

  const setActiveFeature = (section, featureItem) => {
    if (!section || !featureItem) return;

    const wasActive = featureItem.classList.contains('is-active');
    const canHover = window.matchMedia('(hover: hover)').matches;

    if (!canHover && wasActive) {
      closeFeatures(section);
      const activeFeature = featureItem.querySelector(featureSelector);
      if (activeFeature) {
        activeFeature.blur();
      }
      return;
    }

    closeFeatures(section);

    const feature = featureItem.querySelector(featureSelector);
    const detailStack = featureItem.querySelector(detailStackSelector);
    const featuresRoot = section.querySelector('.team-vitality-comfort-victory__features');
    const featureList = featureItem.closest('.team-vitality-comfort-victory__feature-list');

    featureItem.classList.add('is-active');
    if (feature) {
      feature.classList.add('is-active');
      feature.setAttribute('aria-expanded', 'true');
    }
    if (featureList) {
      const featureListRect = featureList.getBoundingClientRect();
      const featureItemRect = featureItem.getBoundingClientRect();
      const offset = featureItemRect.left - featureListRect.left;

      featureItem.style.setProperty('--tvcv-feature-offset', `${offset}px`);
    }
    if (detailStack) {
      detailStack.hidden = false;
    }
    if (featuresRoot) {
      featuresRoot.classList.add('is-detail-open');
    }
    if (!canHover && feature) {
      feature.blur();
    }
  };

  const initSection = (section) => {
    if (!section || section.dataset.tvcvInitialized === 'true') return;

    section.querySelectorAll(featureItemSelector).forEach((featureItem) => {
      const feature = featureItem.querySelector(featureSelector);

      if (!feature) return;

      featureItem.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          setActiveFeature(section, featureItem);
        }
      });
      feature.addEventListener('focus', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          setActiveFeature(section, featureItem);
        }
      });
      feature.addEventListener('click', () => setActiveFeature(section, featureItem));
    });

    const featuresRoot = section.querySelector('.team-vitality-comfort-victory__features');
    if (featuresRoot) {
      featuresRoot.addEventListener('mouseleave', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          closeFeatures(section);
        }
      });
    }

    syncBlacklyteReveal(section);
    revealSection(section);
    section.dataset.tvcvInitialized = 'true';
  };

  const initAll = (root = document) => {
    root.querySelectorAll(sectionSelector).forEach(initSection);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
